import { useContext, useEffect, useState } from "react";

import { memo } from "react";
import { DashBoardContext } from "../contexts/DashBoardContext";
import AccordionDashBoardFinanceiro from "./AccordionDashBoardFinanceiro";

const RenderAccordionsDashBoard = () => {
  const { dashBoardModulesInfo } = useContext(DashBoardContext);
  const [financeiroViewPermission, setFinanceiroViewPermission] =
    useState(false);

  useEffect(() => {
    setFinanceiroViewPermission(dashBoardModulesInfo.financeiro.viewPermission);
  }, [dashBoardModulesInfo]);

  return (
    <>
      {financeiroViewPermission && (
        <AccordionDashBoardFinanceiro
          hiddenAccordionSumary={
            dashBoardModulesInfo.financeiro.hiddenAccordionSumary
          }
        />
      )}
    </>
  );
};

export default memo(RenderAccordionsDashBoard);
